import { render } from "./PlayerAutoVideoEmbed.vue?vue&type=template&id=f7286d0a"
import script from "./PlayerAutoVideoEmbed.vue?vue&type=script&lang=js"
export * from "./PlayerAutoVideoEmbed.vue?vue&type=script&lang=js"

import "./PlayerAutoVideoEmbed.vue?vue&type=style&index=0&id=f7286d0a&lang=scss"
script.render = render

export default script